import * as React from 'react';
import {
    StyledListingCardPortraitLink,
    StyledListingCardPortrait
} from './ListingCardPortrait.styles';

export type ListingCardProps = {
    testId: string;
    listingLinkHref: string;
    onClick: () => void;
    children?: React.ReactNode;
};

export const ListingCardPortrait = ({
    testId,
    listingLinkHref,
    onClick,
    children
}: ListingCardProps) => {
    return listingLinkHref ? (
        <StyledListingCardPortraitLink
            data-testid={testId}
            href={listingLinkHref}
            onClick={onClick}
        >
            {children}
        </StyledListingCardPortraitLink>
    ) : (
        <StyledListingCardPortrait data-testid={testId}>
            {children}
        </StyledListingCardPortrait>
    );
};
